(function () {
  if (typeof window.Sentry === 'undefined') {
    console.warn('Sentry not loaded');
    return;
  }

  window.Sentry.init({
    // If you want override DSN here, uncomment and fill:
    // dsn: "https://yourPublicKey@o0.ingest.sentry.io/yourProjectId",

    environment: Shopify.designMode ? 'theme-editor' : 'production',

    // Enable error only:
    tracesSampleRate: 0.0,

    // Session / performance (optional):
    // notes: change these values based on how much replay you want
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,

    initialScope: {
      tags: {
        shopify_theme: window?.Shopify?.theme?.name || 'unknown',
        shopify_shop: window?.Shopify?.shop || 'unknown',
      },
    },
  });
})();
